__turbopack_context__.v({
  "actionButton": "wfgXhq_actionButton",
  "actions": "wfgXhq_actions",
  "arrowLeft": "wfgXhq_arrowLeft",
  "centeredAssetIcon": "wfgXhq_centeredAssetIcon",
  "closeAction": "wfgXhq_closeAction",
  "content": "wfgXhq_content",
  "createTaskAction": "wfgXhq_createTaskAction",
  "customAddress": "wfgXhq_customAddress",
  "customLatLng": "wfgXhq_customLatLng",
  "customLocationFrom": "wfgXhq_customLocationFrom",
  "geoFenceIcon": "wfgXhq_geoFenceIcon",
  "headerBar": "wfgXhq_headerBar",
  "locationBlock": "wfgXhq_locationBlock",
  "locationFrom": "wfgXhq_locationFrom",
  "locationFromContent": "wfgXhq_locationFromContent",
  "locationFromContentTitle": "wfgXhq_locationFromContentTitle",
  "locationFromTitle": "wfgXhq_locationFromTitle",
  "locationName": "wfgXhq_locationName",
  "locationTo": "wfgXhq_locationTo",
  "locationToContent": "wfgXhq_locationToContent",
  "locationToContentColumn": "wfgXhq_locationToContentColumn",
  "locationToContentColumnContent": "wfgXhq_locationToContentColumnContent",
  "locationToContentColumnTitle": "wfgXhq_locationToContentColumnTitle",
  "locationToError": "wfgXhq_locationToError",
  "locationToHeader": "wfgXhq_locationToHeader",
  "locationToLoading": "wfgXhq_locationToLoading",
  "mainWindow": "wfgXhq_mainWindow",
  "marker": "wfgXhq_marker",
  "title": "wfgXhq_title",
});
